import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const deleteExternalMedia = async ({ id }) => {
  const token = localStorage.getItem("token");

  const response = await axios.delete(`${__API_URL__}/api/photos/delete_external_media/${id}/`, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return response.data;
};

const useDeleteExternalMediaMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteExternalMedia,
    onSuccess: (_data, { caseId }) => {
      queryClient.invalidateQueries({ queryKey: ["external_media_case", caseId] });
    },
    onError: (error) => {
      console.error("Failed to delete external media:", error);
    },
  });
};

export default useDeleteExternalMediaMutation;
